import { useStyletron } from 'baseui';
const ValueChangeCell = ({
  old_value,
  new_value
}) => {
  const [css] = useStyletron();
  return <div className={css({
    display: 'flex',
    width: '100%',
    flexDirection: 'row'
  })}>
      {old_value === new_value ? <p className={css({
      color: '#666'
    })}>{old_value}</p> : <>
          <p className={css({
        color: 'red',
        textDecoration: 'line-through'
      })}>
            {old_value}
          </p>
          <p className={css({
        color: 'green',
        paddingLeft: '.5rem'
      })}>
            {new_value}
          </p>
        </>}
    </div>;
};
export default ValueChangeCell;